var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwapLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5381 40.5149L32.0206 46.9216C32.4853 47.3595 33.2056 47.3595 33.6703 46.9216L40.1529 40.5149C40.8964 39.8005 40.362 38.556 39.3397 38.556L35.1574 38.556L35.1574 24.7055C35.1574 23.438 34.1118 22.401 32.8339 22.401C31.5559 22.401 30.5104 23.438 30.5104 24.7055L30.5104 38.556L26.3513 38.556C25.3057 38.556 24.7946 39.8005 25.5381 40.5149ZM18.0797 7.07558L11.5971 13.4823C10.8536 14.1967 11.388 15.4412 12.4103 15.4412L16.5694 15.4412L16.5694 29.3147C16.5694 30.5822 17.615 31.6193 18.8929 31.6193C20.1708 31.6193 21.2164 30.5822 21.2164 29.3147L21.2164 15.4642L25.3754 15.4642C26.421 15.4642 26.9322 14.2197 26.1887 13.5053L19.7061 7.09863C19.2647 6.63771 18.5211 6.63771 18.0797 7.07558Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(0 54) rotate(-90)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapLogo);
export default __webpack_public_path__ + "static/media/swap_logo.25011f78fe5d2f64e9e8c7f7b91ee67c.svg";
export { ForwardRef as ReactComponent };